import React from 'react';
import { X, Plus } from 'lucide-react';
// Import directly to avoid circular dependency (HoursView cannot import from registry since it was IN the registry)
import HoursRecordsView from './HoursRecordsView';
import { toLocalYMD } from '../../../../utils/dateFmt';
import { usePermissions } from '../../../../hooks/usePermissions';
// FT-356: register onBack with the shell-level MobileBottomBar via context.
import { useSetBackHandler } from '../../../../contexts/NavigationBackContext';


const HoursView = ({
  onBack,
  selectedCrew,
  setSelectedCrew,
  selectedMonth,
  setSelectedMonth,
  crew,
  hoursData,
  crewMember,
  onRecordHours
}) => {
  const { can } = usePermissions();
  useSetBackHandler(onBack);
  
  // Add a selected date (for now, use today)
  const todayIso = toLocalYMD(new Date());
  
  
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Compact Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-3">
              <button
                onClick={onBack}
                className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                title="Close"
              >
                <X className="h-5 w-5" />
              </button>
              <div>
                <h1 className="text-lg sm:text-xl font-semibold text-gray-900">
                  Hours of Rest Records
                </h1>
                {crewMember && (
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mt-1">
                    <p className="text-sm text-gray-500">
                      {crewMember.full_name || crewMember.name} - {crewMember.position}
                    </p>
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800 w-fit">
                      Min 10h/24h, 77h/week rest
                    </span>
                  </div>
                )}
              </div>
            </div>
            
            {/* Action button - only show for Fleet/Skipper */}
            {can('update', 'hours_of_rest') && (
              <button
                onClick={onRecordHours}
                className="inline-flex items-center justify-center w-full sm:w-auto px-4 py-2 text-sm font-medium text-white bg-cyan-600 rounded-md hover:bg-cyan-700"
              >
                <Plus className="h-4 w-4 mr-1" />
                Record Hours
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <HoursRecordsView
          key={(Array.isArray(hoursData) ? hoursData.length : 0) + ':' + (selectedCrew ?? 'none')}
          selectedMonth={selectedMonth}
          setSelectedMonth={setSelectedMonth}
          selectedCrew={selectedCrew}
          selectedCrewId={selectedCrew}
          selectedDate={todayIso}
          crew={crew}
          hoursData={hoursData}
        />
      </div>
    </div>
  );
};

export default HoursView;